/**
 * Transition constants
 */

/**
 * All possible slide transitions
 */
const SlideTransition = {
    SLIDE_LEFT: 'SLIDE_LEFT',
    SLIDE_RIGHT: 'SLIDE_RIGHT'
};

export {SlideTransition};
